// Evito enviar nulls al servidor para que el comportamiento sea análogo al de Protocol Buffers,
// que no envía los nulls por lo que se quedan los valores por defecto establecidos en los
// constructores de los DTOs.
// Además, envío las horas como hora local, no como hora UTC porque si el browser y el servidor
// están en distinta zona horaria, yo quiero que todo se interprete "en crudo", sin hacer

import { DateUtils } from 'core/utils';
import { Level } from './Log';

// conversiones entre una y otra.
const DATE_REQUEST_REGEXP = new RegExp(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/);

const valueReplacer = (_key: any, value: any) => {
	if (value === null)
		return undefined;

	if (typeof value === 'string' && value.match(DATE_REQUEST_REGEXP)) {
		// Convierto otra vez a hora local y serializo
		const date = new Date(value);
		return DateUtils.formatDate(date, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS');
	}

	return value;
};

export function sendToServer(logId: string, date: Date, level: Level, message: string): void {
	void fetch(`${window.location.origin}/log/`, {
		method: 'post',
		headers: {
			'Content-type': 'application/json; charset=utf-8'
		},
		body: JSON.stringify({
			logId, lines: [{ date, level, message }]
		}, valueReplacer)
	})
		.then(response => response.text()) // necesario para evitar memory leaks
		// eslint-disable-next-line no-console
		.catch(error => console.log(`No se ha podido enviar el mensaje de log al servidor ${error}`));
}